import { Component, AfterContentChecked, OnInit, Compiler } from '@angular/core';
import { ConsigmentUploadService } from 'app/cs/service/consignment-upload.service';
declare var $: any;
declare const require: any;

@Component({
  selector: 'cs-modal',
  templateUrl: './cs-modal.component.html',
  styleUrls: ['./cs-modal.component.css']
})
export class CSModalComponent implements OnInit {

  constructor(
    public consigmentUploadService: ConsigmentUploadService,
    private _compiler: Compiler
  ){
    this._compiler.clearCache();
  }

  ngOnInit() {

  }

}




// WEBPACK FOOTER //
// ./src/app/cs/views/cs-modal/cs-modal.component.ts